import { WalletOffer } from "@hopper-b2b/types";
import * as actionTypes from "./constants";

export interface ISetWalletOffers {
  type: actionTypes.SET_WALLET_OFFERS;
  offers?: WalletOffer[];
  creditOffer?: WalletOffer;
  bestOffer?: WalletOffer;
}

export const setWalletOffers = (args: {
  offers?: WalletOffer[];
  creditOffer?: WalletOffer;
  bestOffer?: WalletOffer;
}): ISetWalletOffers => ({
  type: actionTypes.SET_WALLET_OFFERS,
  ...args,
});

export interface IFetchWalletOffers {
  type: actionTypes.FETCH_WALLET_OFFERS;
}

export const fetchWalletOffers = (): IFetchWalletOffers => ({
  type: actionTypes.FETCH_WALLET_OFFERS,
});

export interface ISetWalletOffersFailed {
  type: actionTypes.SET_WALLET_OFFERS_FAILED;
}

export const setWalletOffersFailed = (): ISetWalletOffersFailed => ({
  type: actionTypes.SET_WALLET_OFFERS_FAILED,
});

export interface ISetBestWalletOffer {
  type: actionTypes.SET_BEST_WALLET_OFFER;
  selectedWalletOffer?: WalletOffer;
}

export const setBestWalletOffer = (
  offer?: WalletOffer
): ISetBestWalletOffer => ({
  type: actionTypes.SET_BEST_WALLET_OFFER,
  selectedWalletOffer: offer,
});

export interface ISetSelectedWalletOffer {
  type: actionTypes.SET_SELECTED_WALLET_OFFER;
  selectedWalletOffer?: WalletOffer;
}

export const setSelectedWalletOffer = (
  offer?: WalletOffer
): ISetSelectedWalletOffer => ({
  type: actionTypes.SET_SELECTED_WALLET_OFFER,
  selectedWalletOffer: offer,
});

export interface ISetSelectedCreditOffer {
  type: actionTypes.SET_SELECTED_CREDIT_OFFER;
  selectedCreditOffer?: boolean;
}

export const setSelectedCreditOffer = (
  selectedCreditOffer?: boolean
): ISetSelectedCreditOffer => ({
  type: actionTypes.SET_SELECTED_CREDIT_OFFER,
  selectedCreditOffer: selectedCreditOffer,
});

export type LodgingWalletActions =
  | ISetWalletOffers
  | IFetchWalletOffers
  | ISetWalletOffersFailed
  | ISetSelectedWalletOffer
  | ISetSelectedCreditOffer
  | ISetBestWalletOffer;
